import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import insertScript from '../../../assets/scripts/utilities/insert-script.js'

class TrustpilotEmbedComponent extends Component {
  init() {
    window.addEventListener('init-delayed-load', () => this.startObserver())
  }

  startObserver() {
    this.observer = new IntersectionObserver(entries => this.handleIntersect(entries), { root: null, rootMargin: '0px', threshold: [0, 1] })
    this.observer.observe(this.element)
  }

  async handleIntersect(entries) {
    if (!entries.some(entry => entry.isIntersecting)) {
      return
    }

    await this.initTrustPilot()
    this.observer.disconnect()
  }

  async initTrustPilot() {
    // NOTE: This widget does not set cookies, so a consent check is not required
    await insertScript('trustpilot', 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js')
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'trustpilot-embed', TrustpilotEmbedComponent))
